import React from "react"
import {
  BaseEdge,
  EdgeLabelRenderer,
  EdgeProps,
  getSmoothStepPath
} from "@xyflow/react"

import { AddButton } from "./AddNodeEdge.styled"

export type AddNodeEdgeData = {
  onAddClick?: (edgeId: string) => void
}

const AddNodeEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  style,
  data
}: EdgeProps) => {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 8
  })

  const edgeData = data as AddNodeEdgeData | undefined

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    edgeData?.onAddClick?.(id)
  }

  return (
    <>
      <BaseEdge id={id} path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer>
        <AddButton
          type="button"
          aria-label="Insert node here"
          style={{
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`
          }}
          onClick={handleClick}
          className="nodrag nopan"
        >
          +
        </AddButton>
      </EdgeLabelRenderer>
    </>
  )
}

export default AddNodeEdge
